import {
  jb_home_page_hero_css_default
} from "./chunk.UEKZOYNE.js";
import {
  e
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.534YP5ZJ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n,
  o,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-home-page-hero/jb-home-page-hero.ts
var JbHomePageHero = class extends i {
  constructor() {
    super(...arguments);
    this._classes = { "behind-text-blur": false, "radial-shade": false, "headline-shade": false };
  }
  connectedCallback() {
    super.connectedCallback();
    this._classes = {
      ...this._classes,
      [`align-${this.align ?? "start"}`]: true
    };
  }
  firstUpdated() {
    const img = this._assignedElements[0].querySelector("img");
    if (!img.complete) {
      img.addEventListener(
        "load",
        () => {
          this._setDecorations();
        },
        { once: true }
      );
    } else {
      this._setDecorations();
    }
  }
  _setDecorations() {
    this._classes = {
      ...this._classes,
      "behind-text-blur": this.behindTextBlur,
      "radial-shade": this.radialShade,
      "headline-shade": this.headlineShade
    };
  }
  _tracking(e2) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e2, {
      component_name: "homepage-hero",
      interaction_element: "Internal Links",
      interaction_text: `${this.subline}: ${this.headline}`
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return b`
      <section class="${e(this._classes)}">
        <div class="image-container">
          <div class="shading-filter radial"></div>
          <div class="blur-filter behind-text"></div>

          <slot></slot>

          <div class="over-image-line"></div>
        </div>

        <div class="title-container">
          <jb-heading
            class="headline"
            rank="1"
            variant="title"
            >${this.headline}</jb-heading
          >
          <p class="subline">${this.subline}</p>
        </div>

        <div class="text-container">
          <p class="text">${this.text}</p>

          <div class="button-container">
            <div class="button-wrapper">
              <jb-button-primary
                .forceHover=${this.button.forceHover}
                .inactive=${this.button.inactive}
                .inverted=${this.button.inverted}
                .link=${this.button.link}
                .name=${this.button.name}
                @jb-link:clicked=${this._tracking}
                >${this.buttonText}</jb-button-primary
              >
            </div>
          </div>
        </div>
      </section>
    `;
  }
};
JbHomePageHero.styles = [reset_css_default, jb_home_page_hero_css_default];
__decorateClass([
  n()
], JbHomePageHero.prototype, "align", 2);
__decorateClass([
  n({ type: Boolean })
], JbHomePageHero.prototype, "behindTextBlur", 2);
__decorateClass([
  n({ type: Object })
], JbHomePageHero.prototype, "button", 2);
__decorateClass([
  n()
], JbHomePageHero.prototype, "buttonText", 2);
__decorateClass([
  n({ reflect: true })
], JbHomePageHero.prototype, "headline", 2);
__decorateClass([
  n({ type: Boolean })
], JbHomePageHero.prototype, "headlineShade", 2);
__decorateClass([
  n({ type: Boolean })
], JbHomePageHero.prototype, "radialShade", 2);
__decorateClass([
  n()
], JbHomePageHero.prototype, "subline", 2);
__decorateClass([
  n()
], JbHomePageHero.prototype, "text", 2);
__decorateClass([
  o({ selector: "picture" })
], JbHomePageHero.prototype, "_assignedElements", 2);
__decorateClass([
  r()
], JbHomePageHero.prototype, "_classes", 2);
JbHomePageHero = __decorateClass([
  customElement("jb-home-page-hero")
], JbHomePageHero);

export {
  JbHomePageHero
};
